<header class="dashboard-header">
       <div class="branding">
         <img src="logo.png" alt="logo" class="logo" />
        </div>
        <button class="mobile-menu-btn" aria-label="Toggle menu"  (click)="toggleSidebar()">
        <span></span>
        <span></span>
        <span></span>
      </button>
        <nav class="user-nav">
            <span class="welcome">Welcome, <span id="username">Teacher</span></span>
            <button class="logout-btn">Logout</button>
        </nav>
    </header>

    <div class="dashboard-container">
        <aside class="sidebar">
            <nav class="main-nav">
                <ul>
                    <li class="active"><a><i class="fas fa-home"></i> Dashboard Home</a></li>
                    <li><a><i class="fas fa-graduation-cap"></i> Training Programs</a></li>
                    <li><a><i class="fas fa-book-open"></i> Curriculum Resources</a></li>
                    <li><a><i class="fas fa-shapes"></i> Methodologies</a></li>
                    <li><a><i class="fas fa-users"></i> Community</a></li>
                    <li><a><i class="fas fa-cog"></i> Account Settings</a></li>
                </ul>
            </nav>
            
            <div class="pedagogy-pillars">
                <h3>Three-Pillar Pedagogy</h3>
                <div class="pillar">
                    <i class="fas fa-book"></i>
                    <span>Curriculum</span>
                </div>
                <div class="pillar">
                    <i class="fas fa-laptop-code"></i>
                    <span>Technology</span>
                </div>
                <div class="pillar">
                    <i class="fas fa-chalkboard-teacher"></i>
                    <span>Training</span>
                </div>
            </div>
        </aside>
        

     <aside class="custom-sidebar" [class.open]="isSidebarOpen">
     <nav class="custom-nav">
     <ul>
      <li class="active"><a><i class="fas fa-home"></i> Dashboard Home</a></li>
      <li><a><i class="fas fa-graduation-cap"></i> Training Programs</a></li>
      <li><a><i class="fas fa-book-open"></i> Curriculum Resources</a></li>
      <li><a><i class="fas fa-shapes"></i> Methodologies</a></li>
      <li><a><i class="fas fa-users"></i> Community</a></li>
      <li><a><i class="fas fa-cog"></i> Account Settings</a></li>
     </ul>
    </nav>

    <div class="custom-pillars">
     <h3>Three-Pillar Pedagogy</h3>
     <div class="pillar"><i class="fas fa-book"></i><span>Curriculum</span></div>
     <div class="pillar"><i class="fas fa-laptop-code"></i><span>Technology</span></div>
     <div class="pillar"><i class="fas fa-chalkboard-teacher"></i><span>Training</span></div>
    </div>
     <nav class="user-nav1">
            <span class="welcome">Welcome, <span id="username">Teacher</span></span>
            <button class="logout-btn">Logout</button>
     </nav>
    </aside>

        <main class="main-content">
            <section class="hero-banner">
                <h2>Reinventing teaching in schools</h2>
                <p>Helping educators deploy and co-create innovative pedagogies towards holistic learning outcomes</p>
            </section>

            <div class="dashboard-grid">
                <section class="card upcoming-sessions">
                    <h3><i class="fas fa-calendar-alt"></i> Upcoming Training Sessions</h3>
                    <div class="calendar-view">
                        
                        <div class="calendar-placeholder"></div>
                    </div>
                    <a  class="btn btn-primary" (click)="openRegistration()">Register Now</a>
                </section>

                <section class="card progress-tracker">
                    <h3><i class="fas fa-chart-line"></i> My Progress</h3>
                    <div class="progress-container">
                        <div class="progress-bar">
                            <div class="progress-fill" style="width: 64%;"></div>
                        </div>
                        <span class="progress-text">32/50 hours completed (NEP 2020 requirement)</span>
                    </div>
                    <div class="certification-status">
                        <i class="fas fa-certificate"></i>
                        <span>Certification: In Progress</span>
                    </div>
                </section>

                <section class="card featured-resources">
                    <h3><i class="fas fa-star"></i> Featured Resources</h3>
                    <ul class="resource-list">
                        <li>
                            <i class="fas fa-book"></i>
                            <span>Latest Integrated Theme-Based Book</span>
                            <a  class="download-link"><i class="fas fa-download"></i></a>
                        </li>
                        <li>
                            <i class="fas fa-file-alt"></i>
                            <span>Customizable Lesson Plan Template</span>
                            <a  class="download-link"><i class="fas fa-download"></i></a>
                        </li>
                        <li>
                            <i class="fas fa-heart"></i>
                            <span>Mindfulness Activities Guide</span>
                            <a  class="download-link"><i class="fas fa-download"></i></a>
                        </li>
                    </ul>
                </section>

                <section class="card quick-links">
                    <h3><i class="fas fa-link"></i> Quick Links</h3>
                    <div class="links-grid">
                        <a  class="quick-link">
                            <i class="fas fa-tv"></i>
                            <span>Access CMS Training System</span>
                        </a>
                        <a  class="quick-link">
                            <i class="fas fa-comments"></i>
                            <span>Join Teacher Community</span>
                        </a>
                        <a  class="quick-link">
                            <i class="fas fa-user-tie"></i>
                            <span>Schedule 1:1 Coaching</span>
                        </a>
                    </div>
                </section>

                <section class="card methodology-highlights">
                    <h3><i class="fas fa-lightbulb"></i> Methodology Highlights</h3>
                    <div class="methodology">
                        <h4>A Fusion of Modern Methodologies</h4>
                        <ul>
                            <li>Montessori</li>
                            <li>Waldorf</li>
                            <li>Reggio Emilia</li>
                            <li>HighScope</li>
                        </ul>
                        <p>Our transdisciplinary approach emphasizes hands-on, experiential learning based on child-centered principles.</p>
                    </div>
                </section>

                <section class="card about-us">
                    <h3><i class="fas fa-info-circle"></i> About Us</h3>
                    <p>Kaboodle Innovations is an educational organisation that helps schools and educators deploy and co-create innovative, creative, and practice-based pedagogies through cutting-edge use of technology.</p>
                    <div class="collaboration">
                        <p><strong>In collaboration with:</strong></p>
                        <p>The TeachNiti Foundation</p>
                    </div>
                </section>
            </div>
        </main>
    </div>

    <footer class="dashboard-footer">
        <p>© Kaboodle Innovations in collaboration with TeachNiti Foundation</p>
        <nav class="footer-nav">
           
        </nav>
    </footer>
<app-registration 
  *ngIf="showRegistrationPopup"
  [showPopup]="showRegistrationPopup"
  (closePopup)="closeRegistration()">
</app-registration>
